var _rect, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteriorsInMumbaiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#C5A059",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#E6C786",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 100,
    fill: "transparent"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fontFamily: "serif",
    fontSize: 36,
    fill: "url(#goldGradient)",
    fontWeight: "bold",
    letterSpacing: 1
  }, "\n    Interiors in Mumbai\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "75%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#333",
    letterSpacing: 4
  }, "\n    LUXURY DESIGN STUDIO\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteriorsInMumbaiLogo);
export default __webpack_public_path__ + "static/media/interiors_in_mumbai_logo.94e893b3f0a2b14771e5e3c20de44dd9.svg";
export { ForwardRef as ReactComponent };